module.exports = __webpack_public_path__ + "img/logo1.62966901.png";